import Vue from "vue";
import VueRouter from "vue-router";
// https://github.com/declandewet/vue-meta
import store from "@/store/store";
import { ROUTES, ROUTES_FOR_ROUTER } from "@/router/routes";
import ADMIN_ROUTES from "@admin/routes";
import APP_ROUTES from "@app/routes";
import AuthService from "@/services/Auth";
import UserService from "@/services/User";

import * as Firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    ...ADMIN_ROUTES,
    {
      path: "/",
      component: () => import("@/sections/app/Index"),
      children: [...APP_ROUTES, ...ROUTES_FOR_ROUTER]
    }
  ],
  base: process.env.BASE_URL,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  const adminRequired = to.matched.some(route => route.meta.adminRequired);
  const authRequired = to.matched.some(route => route.meta.authRequired);
  const verifiedOnly = to.matched.some(route => route.meta.verifiedOnly);

  // If auth isn't required for the route, just continue.
  if (adminRequired || authRequired || verifiedOnly) {
    const user = await AuthService.refreshCurrentUser();

    if (!user) {
      redirectToLogin();
      return;
    }

    if (verifiedOnly && !user.emailVerified) {
      redirectToVerify();
      return;
    }

    if (adminRequired && !store.getters["user/isAdmin"]) {
      user.getIdToken(true).then(token => {
        AuthService.updateToken(token);
        UserService.getUser()
          .then(user => {
            if (!user.data.admin) {
              throw "Not Admin";
            }
          })
          .catch(e => {
            redirectToHome();
            return;
          });
      });
    }
  }

  checkStyle(to, from, next);

  function redirectToLogin() {
    // Pass the original route to the login component;
    next({ name: ROUTES.signIn.name, query: { redirectFrom: to.fullPath } });
  }

  function redirectToVerify() {
    // Pass the original route to the login component
    next({ name: ROUTES.verify.name, query: { redirectFrom: to.fullPath } });
  }

  function redirectToHome() {
    // Pass the original route to the login component
    next({ name: ROUTES.home.name, query: { redirectFrom: to.fullPath } });
  }

  function checkStyle() {
    if (to.path === ROUTES.create.path) {
      if (!store.getters["creator/getSongStyle"]) {
        next(ROUTES.style.path);
      }
    }
    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  next();
});

// When each route is finished evaluating...
router.afterEach((routeTo, routeFrom) => {});
export default router;
